import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'core/services/auth.service';
import { User } from 'shared/types/user.model';
import { TranslateModule } from '@ngx-translate/core';
import { KorviuButtonComponent } from 'shared/components/korviu-button/korviu-button.component';

@Component({
  selector: 'app-ready-to-apply',
  templateUrl: './ready-to-apply.component.html',
  styleUrl: './ready-to-apply.component.scss',
  standalone: true,
  imports: [TranslateModule, KorviuButtonComponent]
})
export class ReadyToApplyComponent {
  public get currentUser(): User {
    return this._authService.currentUser;
  }

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _authService: AuthService
  ) {}

  public onApplyToOkeeyCashClick(): void {
    const referralId: number = this.currentUser.id;
    const link: string = `https://usa.okeeycash.com/web/UNIGANA?externalReferenceCode=${referralId}`;
    window.open(link, '_blank');
  }

  public onBackToDashboardClick(): void {
    this._router.navigate(['workspace', 'dashboard']);
  }

  public onQuickGuideClick(): void {
    this._router.navigate(['apply'], { relativeTo: this._route.parent });
  }
}
